import { Validator } from 'services/validator'
import { MAX_PRICE_INPUT_NAME, MIN_PRICE_INPUT_NAME, MAX_PRICE_ERROR_MSG, MIN_PRICE_ERROR_MSG } from './constants'

export default Validator.combineValidators({
  [MAX_PRICE_INPUT_NAME]: {
    errorMessage: MAX_PRICE_ERROR_MSG,
    validators: [Validator.required(), Validator.notLessThan(MIN_PRICE_INPUT_NAME), Validator.greaterThan(0)]
  },
  [MIN_PRICE_INPUT_NAME]: {
    errorMessage: MIN_PRICE_ERROR_MSG,
    validators: Validator.required()
  }
})
